import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'
import Ls from "@/services/ls";

let orders = Ls.get('orders')
const initialState = {
    cart: orders ? JSON.parse(orders) :[],
}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}